import heroBanner from '@/assets/landing/images/hero-banner.png';
import arrowImage from '@/assets/landing/images/arrow.svg';
import smileLightImage from '@/assets/landing/images/smile-light.svg';
import liveNameImage from '@/assets/landing/images/live-name.svg';
import heroCoverBg from '@/assets/landing/images/hero-cover-bg.svg';
import smileReflectImage from '@/assets/landing/images/smile-reflect.svg';
import rocketEmoji from '@/assets/landing/images/rocket-emoji.png';
import shockedEmoji from '@/assets/landing/images/shocked-emoji.png';
import heartEmoji from '@/assets/landing/images/heart-emoji.png';
import fireEmoji from '@/assets/landing/images/fire-emoji.png';
import warningEmoji from '@/assets/landing/images/warning-emoji.png';
import skateMusicEmoji from '@/assets/landing/images/skate-music-emoji.png';
import eyeImage from '@/assets/landing/images/eye.png';

export default function Hero() {
  return (
    <section className="bg-highlight py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12">
      <div className="landing-container px-3 sm:px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[430px_1fr] items-center justify-center gap-6 sm:gap-8 lg:gap-16">
          <div className="text-center lg:text-left order-2 lg:order-1">
            <span className="text-black text-[60px] sm:text-[80px] md:text-[100px] lg:text-[136px] font-['Times_New_Roman'] leading-tight">
              <span>Culture</span>
              <br />
              <div className="relative flex items-center justify-center lg:justify-start">
                <div className="flex-shrink-0 flex items-center relative flex-1 max-w-[200px] sm:max-w-[250px] lg:max-w-none">
                  <img src={arrowImage} alt="Arrow" className="w-16 sm:w-20 md:w-24 lg:w-32 absolute shrink-0" />
                  <img src={arrowImage} alt="Arrow" className="w-16 sm:w-20 md:w-24 lg:w-32 absolute left-[20%] shrink-0" />
                  <img src={arrowImage} alt="Arrow" className="w-16 sm:w-20 md:w-24 lg:w-32 absolute left-[40%] shrink-0" />
                </div>
                <img src={eyeImage} alt="Eyes" className="w-[60px] sm:w-[80px] md:w-[100px] lg:w-[117px] shrink-0" />
              </div>
              <span>Monitor</span>
              <div className="relative flex items-center justify-center lg:justify-start">
                <img src={smileLightImage} alt="Smile" className="w-20 sm:w-24 md:w-28 lg:w-36 shrink-0" />
                <img src={liveNameImage} alt="Live" className="w-24 sm:w-32 md:w-40 lg:w-56 shrink-0" />
              </div>
            </span>
          </div>
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative">
            <img src={heroCoverBg} alt="Hero Background" className="absolute inset-0 w-full h-full object-cover z-0 shrink-0" />
            <img src={heroBanner} alt="Culture Monitor" className="w-full h-auto object-contain relative z-10 shrink-0" />
            <div className="absolute left-1 sm:left-2 flex flex-col gap-1 sm:gap-2 top-1/2 transform -translate-y-1/2 z-20">
              <div className="opacity-0 animate-[fadeInUp_0.6s_ease-out_0.3s_forwards]">
                <img src={rocketEmoji} alt="Rocket" className="w-[60px] sm:w-[80px] md:w-[100px] lg:w-[112px] h-auto shrink-0" />
              </div>
              <div className="hidden md:block bg-white/50 backdrop-blur-lg shadow-2xl border border-white/40 p-2 sm:p-3 max-w-[140px] sm:max-w-[200px] md:max-w-[240px] lg:max-w-[260px] opacity-0 animate-[fadeInUp_0.6s_ease-out_0.5s_forwards]" style={{ borderRadius: '14px' }}>
                <div className="flex items-center gap-1 sm:gap-2">
                  <span className="opacity-0 animate-[fadeInUp_0.6s_ease-out_0.7s_forwards] shrink-0">
                    <img src={fireEmoji} alt="Fire" className="w-[20px] sm:w-[24px] md:w-[28px] h-auto" />
                  </span>
                  <span className="text-[10px] sm:text-[12px] md:text-[14px] font-medium text-gray-800">
                    <strong>Insight aprovado</strong> pelo cliente no Culture Monitor
                  </span>
                </div>
              </div>
            </div>
            <div className="absolute bottom-1 sm:bottom-2 right-1 sm:right-2 flex items-center gap-1 sm:gap-2 z-20">
              <div className="opacity-0 animate-[fadeInUp_0.6s_ease-out_1.0s_forwards]">
                <img src={shockedEmoji} alt="Shocked" className="w-[50px] sm:w-[60px] md:w-[70px] lg:w-[80px] h-auto shrink-0" />
              </div>
              <div className="hidden md:block bg-white/50 backdrop-blur-lg shadow-2xl border border-white/40 p-3 max-w-[200px] sm:max-w-[220px] md:max-w-[240px] lg:max-w-[260px] opacity-0 animate-[fadeInUp_0.6s_ease-out_1.2s_forwards]" style={{ borderRadius: '14px' }}>
                <div className="flex items-center gap-2">
                  <span className="opacity-0 animate-[fadeInUp_0.6s_ease-out_1.4s_forwards] shrink-0">
                    <img src={warningEmoji} alt="Warning" className="w-[20px] sm:w-[24px] md:w-[28px] h-auto" />
                  </span>
                  <span className="text-[14px] font-medium text-gray-800">
                    <strong>Esse tema está em alta,</strong> mas você ainda não cobriu.
                  </span>
                </div>
              </div>
            </div>
            <div className="absolute top-1 sm:top-2 right-1 sm:right-2 flex items-center justify-center flex-col gap-1 sm:gap-2 z-20">
              <div className="opacity-0 animate-[fadeInUp_0.6s_ease-out_1.7s_forwards]">
                <img src={heartEmoji} alt="Heart" className="w-[40px] sm:w-[50px] md:w-[56px] lg:w-[62px] h-auto shrink-0" />
              </div>
              <div className="hidden md:block bg-white/50 backdrop-blur-lg shadow-2xl border border-white/40 p-3 max-w-[200px] sm:max-w-[220px] md:max-w-[240px] lg:max-w-[260px] opacity-0 animate-[fadeInUp_0.6s_ease-out_1.9s_forwards]" style={{ borderRadius: '14px' }}>
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap opacity-0 animate-[fadeInUp_0.6s_ease-out_2.1s_forwards] shrink-0">
                    <img src={skateMusicEmoji} alt="Skate Music" className="w-[50px] sm:w-[60px] md:w-[70px] lg:w-[77px] h-auto shrink-0" />
                  </span>
                  <span className="text-[14px] font-medium text-gray-800">
                    <strong>Território em alta:</strong> Skate + Música
                  </span>
                </div>
              </div>
            </div>
            <div className="absolute bottom-2 left-1/4 z-20">
              <img src={smileReflectImage} alt="Smile Reflect" className="w-16 sm:w-20 md:w-24 lg:w-32 shrink-0" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

